// NOTE: while the AGG goal directory is under construction it lives at its
// own URL (/agg-goals, /agg-goals/following, /agg-goals/archived) — a
// development surface that runs in parallel with the legacy /goals routes
// rather than masking them via a feature gate. The featureGating block is
// retained so the routes are only registered for tenants opted into
// `townsquare_agg_goal_directory`; merging the two URL surfaces into one
// (i.e. /goals served by either the legacy or AGG view based on the gate)
// is a separate human-driven cutover and must NOT be attempted by the AI
// during the port — see PLAN.md and townsquare-agg-port skill for the
// rationale.
import {
	AGG_GOAL_DIRECTORY_ARCHIVED_PAGE,
	AGG_GOAL_DIRECTORY_ARCHIVED_PATH,
	AGG_GOAL_DIRECTORY_FOLLOWING_PAGE,
	AGG_GOAL_DIRECTORY_FOLLOWING_PATH,
	AGG_GOAL_DIRECTORY_PAGE,
	AGG_GOAL_DIRECTORY_PATH,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const aggGoalDirectoryRoute = createGlobalRoute({
	exact: true,
	name: AGG_GOAL_DIRECTORY_PAGE,
	path: AGG_GOAL_DIRECTORY_PATH,
	capabilities: ['goals_app:access'],
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['townsquare_agg_goal_directory'],
		behavior: { type: 'enabled' },
	},
});

export const aggGoalDirectoryFollowingRoute = createGlobalRoute({
	exact: true,
	name: AGG_GOAL_DIRECTORY_FOLLOWING_PAGE,
	path: AGG_GOAL_DIRECTORY_FOLLOWING_PATH,
	capabilities: ['goals_app:access'],
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['townsquare_agg_goal_directory'],
		behavior: { type: 'enabled' },
	},
});

export const aggGoalDirectoryArchivedRoute = createGlobalRoute({
	exact: true,
	name: AGG_GOAL_DIRECTORY_ARCHIVED_PAGE,
	path: AGG_GOAL_DIRECTORY_ARCHIVED_PATH,
	capabilities: ['goals_app:access'],
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['townsquare_agg_goal_directory'],
		behavior: { type: 'enabled' },
	},
});
